import { DataIdConverterFactory } from 'src/app/core/services/mapper/data-id.converter';
import { Service } from '../../intervenant/models/service.model';
import { RefSoustypeUtilisateur } from './ref-soustype-utilisateur.model';
import { DroitFonctionnel } from './droit-fonctionnel.model';

export class DroitProfil {
    static jsonMap = {
        id: { key: 'id' },
        code: { key: 'code', optional: true, default: '' },
        libelle: { key: 'libelle', optional: true, default: '' },
        soustype: { key: 'idRefSousType', converter: new (DataIdConverterFactory.build(RefSoustypeUtilisateur, 'soustypesUtilisateurs'))() },
        service: { key: 'idService', converter: new (DataIdConverterFactory.build(Service, 'services'))() }
    };

    public id: number;
    public libelle: string;
    soustype: RefSoustypeUtilisateur;
    service: Service;

    droitsFonctionnels: DroitFonctionnel[] = [];
}
